// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"615439d8","373":"3d7355f0","462":"3fab56d6"}[chunkId] + ".chunk.css";
};